"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_icons.HomeOutlined, null), " ", /*#__PURE__*/_react.default.createElement(_icons.SettingFilled, null), " ", /*#__PURE__*/_react.default.createElement(_icons.SmileOutlined, null), " ", /*#__PURE__*/_react.default.createElement(_icons.SyncOutlined, {
    spin: true
  }), /*#__PURE__*/_react.default.createElement(_icons.SmileOutlined, {
    rotate: 180
  }), " ", /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, null));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  key: 'default'
};
var _default = exports.default = componentDemo;